import { lazy, Suspense } from "react";
import Icon from "@mui/material/Icon";

import {
  SUPER_ADMIN_ROLE,
  SUPERVISEUR_ROLE,
  ADMIN_PAYS_ROLE,
  ADMIN_DIRECTION_ROLE,
  ADMIN_SOUS_SECTEUR_ROLE,
  ADMIN_REGION_ROLE,
  ADMIN_DEPARTEMENTAL_ROLE,
  RESPONSABLE_FERME,
} from "constant/role";
import SuspenceComponent from "components/SuspenceComponent";

const Demolayout = lazy(() => import("layouts/demoLayout"));
const DemoDashboardlayout = lazy(() => import("layouts/demoLayout/demoDashboardLayoutComponent"));
const ROUTES_DEMO = [
  {
    type: "collapse",
    name: <span style={{ color: "black" }}>Demo</span>,
    key: "demo",
    icon: (
      <Icon fontSize="small" style={{ color: "black" }}>
        peopleAltIcon
      </Icon>
    ),
    route: "/demoLayout",
    component: (
      <Suspense fallback={<SuspenceComponent />}>
        <Demolayout />
      </Suspense>
    ),
    role: [
      SUPER_ADMIN_ROLE,
      SUPERVISEUR_ROLE,
      ADMIN_PAYS_ROLE,
      ADMIN_DIRECTION_ROLE,
      ADMIN_SOUS_SECTEUR_ROLE,
      ADMIN_REGION_ROLE,
      ADMIN_DEPARTEMENTAL_ROLE,
      RESPONSABLE_FERME,
    ],
    collapse: [
      {
        name: "Table",
        key: "demoLayout",
        route: "/demoLayout1",
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <Demolayout />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: "Demo",
        key: "demoLayout",
        route: "/demoLayout",
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <Demolayout />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: "Dashboard",
        key: "demoDashbordLayout",
        route: "/demoDashbordLayout",
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <DemoDashboardlayout />
          </Suspense>
        ),
        collapse: [],
      },
    ],
  },
];
export default ROUTES_DEMO;
